
import { Tooltip } from 'antd';
import UserAvatar from 'components/userAvatar';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { Api } from 'services';
import bellIcon from "../Assets/layout/newFilledIcons/bell.svg";
import userIcon from '../Assets/layout/newFilledIcons/user-accout.svg';
import userIconSettings from '../Assets/layout/newFilledIcons/user-account-settings.svg';
import logoutIcon from '../Assets/layout/newFilledIcons/user-logout-red.svg';

const popover = (visible, collapsed) => ({
  position: "absolute",
  bottom: "2%",
  left: collapsed ? `clamp(70px, 2vw, 90px)` : `clamp(110px, 16vw, 200px)`,
  display: visible ? "block" : "none",
  padding: "0 0px 0px 40px",
  zIndex: '1000',
})

export const CollapsedProfileMenu = ({ user, userDetails, visible, onLogout, onProfileClick, onNotificationClick, collapsed, notificationCount, setMiniProfileMenu }) => {
  const menuRef = useRef(null);

  // Detect clicks outside the profile menu
 
  return (
    <div onMouseLeave={()=>{setMiniProfileMenu(false)}} style={popover(visible, collapsed) }>
      <div className={`userProfileMenu`} style={{ zIndex: 111111}}>
        {/* Profile Section */}
        <div className="profile-section" style={{ marginBottom: -10 }}>
          <UserAvatar
            fromProfileMenu={true}
            size="5vmin"
            shape="circle"
            name={user.name}
            img={user.image == "default.png" ? "" : `${Api._s3_url}${user.image}`}
            backgroundColor={userDetails?.backgroundColor || user?.backgroundColor}
            textColor={userDetails?.textColor || user?.textColor} />
          <Tooltip title={user.name} placement="top">
            <div
              className="user-name"
              style={{
                maxWidth: "155px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {user.name}
            </div>
          </Tooltip>

        </div>

        {/* Action Buttons */}
        <div className="action-buttons" style={{ marginLeft: 35, marginBottom: 20 }}>
          {/* Notification Button */}
          <Tooltip title="Notifications" mouseEnterDelay={0.6}>
            <div className="action-button" onClick={onNotificationClick}>
              <div className="button-content">
                <img src={bellIcon} alt="Notifications" className="icon" />
                {(notificationCount > 0 || notificationCount == '9+') && <span className="badge">{notificationCount}</span>}
              </div>
            </div>
          </Tooltip>

          {/* Profile Button */}
          <Tooltip title={user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes("Admin") ? 'Account settings' : 'Account'} mouseEnterDelay={0.6}>
            <div className="action-button" onClick={onProfileClick}>
              <div className="button-content">
                <img
                  src={
                    user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes("Admin")
                      ? userIconSettings
                      : userIcon
                  }
                  alt="Profile"
                  className="icon"
                />
              </div>
            </div>
          </Tooltip>

          {/* Logout Button */}
          <Tooltip title="Logout" mouseEnterDelay={0.6}>
            <div className="action-button" onClick={onLogout}>
              <div className="button-content">
                <img src={logoutIcon} alt="Logout" className="icon" />
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}